import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, connectFirestoreEmulator, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAYldlU_hwK7ZQcVW_pI5WbW_0DxGxpFsI",
  authDomain: "lsqstays-d83be.firebaseapp.com",
  projectId: "lsqstays-d83be",
  storageBucket: "lsqstays-d83be.firebasestorage.app",
  messagingSenderId: "630487112064",
  appId: "1:630487112064:web:a80dab102013dc38f3c965",
  measurementId: "G-JPR853PL6G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

// Enable Firestore caching for offline support and reduced reads
enableIndexedDbPersistence(db)
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled in one tab at a time
    } else if (err.code === 'unimplemented') {
      // The current browser does not support all of the features required to enable persistence
    }
    // Error handling done silently
  });

export { db, auth };